import React from "react";
import {Section,Title,Columns,Column} from 'bloomer'
import Calendar from '../components/body/calendar';
import Hero from '../components/hero'
import PropTypes from "prop-types";
const TITLE = 'School Calendar'
const Component = ({events,heroClass}) => {
  return (
    <div>
      <div id="carousel-wrap">
        <Hero
          className={heroClass}
          images={[]}
          getBody={()=><Title
            style={{marginTop:'1em'}}
            className='is-hidden-mobile'>
              {TITLE}
          </Title>}
        />
      </div>
      <Section  className={'row'}>
        <Title className='is-hidden-desktop'>
          {TITLE}
        </Title>
        <Columns isCentered >
          <Column style={{height:'30rem'}} >
            <Calendar
              events={events}
            />
          </Column>
        </Columns>
      </Section>
    </div>
  );
};

Component.propTypes = {
  events:PropTypes.array,
  heroClass:PropTypes.string
};
Component.defaultProps = {};

export default Component;






